import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-reason-detail-modal",
  templateUrl: "./reason-detail-modal.component.html",
  styleUrls: ["./reason-detail-modal.component.scss"],
})
export class ReasonDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ReasonDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      subHeading: boolean;
      heading: string;
      reason: string;
      submitButton?: string;
      reasonLabel?: string;
      iconPath?: string;
      backButtonName?: string;
    }
  ) {}
  submit() {
    this.dialogRef.close(true);
  }

  back() {
    this.dialogRef.close(null);
  }
}
